import { ReactNode } from "react";
import styles from "./Text.module.css";
import clsx from "clsx";
import adjustStyles from "../Adjust/Adjust.module.css";
import { AdjustProps } from "../Adjust/Adjust";

export enum TextType {
  NORMAL = "",
  CAUTION = "caution",
  EMPHASIS = "emphasis",
  EXPIRED = "expired",
  ANNOTATION = "annotation",
  SYMBOL = "symbol",
}

interface TextContentProps {
  type?: TextType;
  text?: string | ReactNode;
}

export interface ParagraphProps {
  type?: TextType;
  text?: ReactNode | string;
  leadSentence?: string;
  onRenderParagraph?: () => JSX.Element | null;
}

export interface TextProps {
  textItems: ParagraphProps[];
  adjust?: Pick<AdjustProps, "mb">;
  className?: string;
}

const TextContent = (props: TextContentProps) => {
  const { type, text } = props;

  if (type === TextType.EMPHASIS) {
    return <em>{text}</em>;
  }

  if (type === TextType.CAUTION) {
    return <strong>{text}</strong>;
  }

  if (type === TextType.ANNOTATION) {
    return (
      <>
        {text}
        <sup>※</sup>
      </>
    );
  }

  if (type === TextType.EXPIRED) {
    return <s>{text}</s>;
  }

  if (type === TextType.SYMBOL) {
    return (
      <>
        <span>※ </span>
        {text}
      </>
    );
  }
  return <>{text}</>;
};

const Paragraph = (props: ParagraphProps) => {
  const { type, text, leadSentence, onRenderParagraph } = props;

  if (onRenderParagraph) {
    return onRenderParagraph();
  }

  if (leadSentence) {
    return (
      <p>
        <b className={styles["lede"]}>{leadSentence}</b>
        {text && <TextContent type={type} text={text} />}
      </p>
    );
  }

  return <p>{text && <TextContent type={type} text={text} />}</p>;
};

export const Text = (props: TextProps) => {
  const { textItems, adjust, className } = props;
  const componentStyles = clsx({
    [styles["mod-txt"]]: true,
    [adjustStyles[`mb-` + adjust?.mb]]: !!adjust,
    [className ?? ""]: true,
  });

  return (
    <div className={componentStyles}>
      {textItems.length > 0 &&
        textItems.map((item: ParagraphProps, index: number) => {
          return <Paragraph key={index} {...item} />;
        })}
    </div>
  );
};
